module.exports = __webpack_public_path__ + "static/virtual-reality-demos-in-warehouse-6ccc3c1a1febbf82ab9e3936e1f66b16.jpg";